import { Directive } from 'vue'

interface CustomElement extends HTMLElement {
  _horizontalScrollHandler?: (e: WheelEvent) => void;
}

export const vHorizontalScroll: Directive = {
  mounted (el: CustomElement) {
    const onWheel = (e: WheelEvent) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return

      e.preventDefault()

      const momentum = 1.5
      el.scrollLeft += e.deltaY * momentum
    }

    el._horizontalScrollHandler = onWheel
    el.addEventListener('wheel', onWheel, { passive: false })
  },
  unmounted (el: CustomElement) {
    if (el._horizontalScrollHandler) {
      el.removeEventListener('wheel', el._horizontalScrollHandler)
    }
  },
}
